/**
 * Container: Contains all relavent functions relating to the context provider and consumer
 * Including:
 * - VerificationProvider
 * - useDomainVerification
 */

import React, { createContext, useContext } from 'react';
import useDomainVerificationImpl from './useDomainVerification';

const VerificationContext = createContext();

export function VerificationProvider(props) {
  const { children } = props;
  const verificationState = useDomainVerificationImpl();

  return (
    <VerificationContext.Provider value={verificationState}>
      { children }
    </VerificationContext.Provider>
  );
}

export function useDomainVerification() {
  return useContext(VerificationContext);
}
